import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AddEditForm from "pages/EmployeeWorkspace/components/Tabs/components/WorkExperienceTab/components/AddEditForm";
import { formatDateForInput } from "utils/helpers/dateHelper";
import resource from "pages/EmployeeWorkspace/Resources/workExperienceResource";

import schema from "pages/EmployeeWorkspace/validation/workExperienceSchema";

const defaultValues = {
    accreditation: "",
    dateTaken: null,
    placeTaken: null,
    licenseNumber: null,
    validityDate: null
};

const updateGuard = (data) => {
    return {
        payRate: data.payRate ? data.payRate : null,
        endDate: data?.endDate || null
    };
};

const dateFormatter = (item) => {
    return {
        endDate: formatDateForInput(item?.endDate)
    };
};

export default function FormDialog({ open, item, onSave, onCancel }) {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm({
        defaultValues,
        resolver: yupResolver(schema)
    });

    const onError = (errors) => {
        console.log({ errors });
    };

    useEffect(() => {
        if (open) {
            reset({
                ...defaultValues,
                ...item,
                ...dateFormatter(item)
            });
        }
    }, [open, item, reset]);

    const onSubmit = (data) => {
        onSave({
            ...data,
            ...updateGuard(data)
        });
    };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="md" fullWidth>
            <DialogTitle>
                {item ? `Edit ${resource.title}` : `Add ${resource.title}`}
            </DialogTitle>

            <DialogContent dividers>
                <AddEditForm
                    register={register}
                    errors={errors}
                    control={control}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit(onSubmit, onError)}
                >
                    Apply
                </Button>
            </DialogActions>
        </Dialog>
    );
}
